var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-bread-crumb"},[_c('Breadcrumb',_vm._l((_vm.list),function(item){return _c('BreadcrumbItem',{key:`bread-crumb-${item.name}`,attrs:{"to":item.to}},[_c('Icon',{staticStyle:{"margin-right":"4px"},attrs:{"type":item.icon || ''}}),_vm._v(" "+_vm._s(item.meta.title)+" ")],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }